import React, { useState, useRef } from 'react';
import { Captcha, CaptchaHandle } from '../../components/Captcha';
const PROGRAM_OPTIONS = ['Mini Troopers', 'Kids Taekwondo', 'Adult Classes', 'Family Classes', 'Self-Defense', 'Competition Team', 'Summer Camp', 'General Question'];
const HEARD_ABOUT_OPTIONS = ['Google Search', 'Google Maps', 'Facebook / Instagram', 'Friend or Family', 'Drove By', 'Storm Student', 'Other'];
interface FieldProps extends React.InputHTMLAttributes<HTMLInputElement> {
  id: string;
  label: string;
  optional?: boolean;
}
function Field({
  id,
  label,
  optional,
  ...rest
}: FieldProps) {
  return <div data-id="element-2751">
      <label htmlFor={id} className="block text-sm font-bold text-ink mb-2 uppercase tracking-wide" data-id="element-2752">
        {label}{' '}
        {optional && <span className="text-gray-warm font-normal normal-case text-xs" data-id="element-2753">
            (optional)
          </span>}
      </label>
      <input id={id} name={id} className="w-full px-4 py-3 rounded-xl border border-subtle-gray bg-off-white focus:outline-none focus:ring-2 focus:ring-storm-red focus:border-transparent transition-all" {...rest} data-id="element-2754" />
    </div>;
}
export function Page31HeroForm() {
  const [captchaValid, setCaptchaValid] = useState(false);
  const captchaRef = useRef<CaptchaHandle>(null);
  return <div id="signup-form" className="bg-paper p-8 rounded-2xl shadow-2xl border border-subtle-gray relative scroll-mt-24" data-id="element-2755">
      <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-storm-red text-white px-6 py-2 rounded-full font-bold uppercase tracking-wide whitespace-nowrap shadow-lg text-sm" data-id="element-2756">
        Find Your Starting Class
      </div>

      {/* === INSERT WEBSITEFORGE SIGNUP FORM FRAME HERE === */}
      {/* Replace this <form> with the live WebsiteForge signup embed in   */}
      {/* production so submissions reach Storm Taekwondo's real inbox/CRM. */}
      <form action="/thank-you-free-trial" method="get" className="mt-4 flex flex-col gap-5" data-id="element-2757">
        <div className="grid grid-cols-2 gap-4" data-id="element-2758">
          <Field id="firstName" label="First Name" type="text" required autoComplete="given-name" placeholder="Jane" data-id="element-2759" />
          <Field id="lastName" label="Last Name" type="text" required autoComplete="family-name" placeholder="Doe" data-id="element-2760" />
        </div>

        <Field id="email" label="Email" type="email" required autoComplete="email" placeholder="email@example.com" data-id="element-2761" />

        <Field id="cellPhone" label="Cell Phone" type="tel" required autoComplete="tel" placeholder="(517) 220-0621" data-id="element-2762" />

        <div data-id="element-2763">
          <label htmlFor="interestedIn" className="block text-sm font-bold text-ink mb-2 uppercase tracking-wide" data-id="element-2764">
            Interested In
          </label>
          <select id="interestedIn" name="interestedIn" required defaultValue="" className="w-full px-4 py-3 rounded-xl border border-subtle-gray bg-off-white focus:outline-none focus:ring-2 focus:ring-storm-red focus:border-transparent transition-all" data-id="element-2765">
            <option value="" disabled data-id="element-2766">
              Choose a class or program
            </option>
            {PROGRAM_OPTIONS.map(opt => <option key={opt} value={opt} data-id="element-2767">
                {opt}
              </option>)}
          </select>
        </div>

        <Field id="childAge" label={"Child's Age"} optional type="number" inputMode="numeric" min={3} max={17} placeholder="e.g. 6" data-id="element-2768" />

        <div data-id="element-2769">
          <label htmlFor="heardAbout" className="block text-sm font-bold text-ink mb-2 uppercase tracking-wide" data-id="element-2770">
            How Did You Hear About Us?
          </label>
          <select id="heardAbout" name="heardAbout" defaultValue="" className="w-full px-4 py-3 rounded-xl border border-subtle-gray bg-off-white focus:outline-none focus:ring-2 focus:ring-storm-red focus:border-transparent transition-all" data-id="element-2771">
            <option value="" disabled data-id="element-2772">
              Select an option
            </option>
            {HEARD_ABOUT_OPTIONS.map(opt => <option key={opt} value={opt} data-id="element-2773">
                {opt}
              </option>)}
          </select>
        </div>

        <Captcha ref={captchaRef} onValidChange={setCaptchaValid} data-id="element-2774" />

        <button type="submit" disabled={!captchaValid} className="btn-primary w-full disabled:opacity-70 disabled:cursor-not-allowed" data-id="element-2775">
          Check Availability
        </button>

        <p className="text-xs text-gray-warm text-center leading-relaxed" data-id="element-2776">
          A Storm coach will reach out to confirm trial and enrollment options.
          For faster help call{' '}
          <a href="tel:517-220-0621" className="font-bold text-storm-red hover:underline" data-id="element-2777">
            517-220-0621
          </a>{' '}
          or email{' '}
          <a href="mailto:info@stormtaekwondo.com" className="font-bold text-storm-red hover:underline" data-id="element-2778">
            info@stormtaekwondo.com
          </a>
          .
        </p>
      </form>
    </div>;
}